import { Component, OnInit, ChangeDetectionStrategy, inject, signal } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { WebAuthnRegisterModalComponent } from '../../shared/components/two-factor-auth/webauthn-register-modal/webauthn-register-modal.component';

@Component({
    selector: 'app-auth-register',
    standalone: true,
    imports: [WebAuthnRegisterModalComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [`
        :host {
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 100vh;
            background: var(--stela-aubergine);
        }
    `],
    template: `
        <webauthn-register-modal
            [visible]="modalVisible()"
            [token]="token()"
            (visibleChange)="onVisibleChange($event)"
            (registered)="onRegistered()" />
    `
})
export class AuthRegisterComponent implements OnInit {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);

    readonly modalVisible = signal(false);
    readonly token = signal('');

    ngOnInit(): void {
        this.token.set(this.route.snapshot.params['token'] || '');
        this.modalVisible.set(true);
    }

    onVisibleChange(visible: boolean): void {
        if (!visible) {
            this.router.navigate(['/auth/init']);
        }
    }

    onRegistered(): void {
        this.router.navigate(['/auth/init']);
    }
}
